import { Skeleton } from '@/components/Skeleton/Skeleton'
import { yStack } from 'ui/src/patterns/stack'
import { container } from './InsuranceGuide.css'

export function InsuranceGuideSkeleton() {
  return (
    <div>
      <Skeleton style={{ height: '4px', borderRadius: 0 }} />

      <div className={container}>
        <div className={yStack({ gap: 'xl' })}>
          <div className={yStack({ gap: 'xs', alignItems: 'center' })}>
            <Skeleton style={{ height: '28px', width: '60%' }} />
            <Skeleton style={{ height: '20px', width: '80%' }} />
          </div>

          <Skeleton style={{ height: '48px' }} />

          <div className={yStack({ gap: 'xs' })}>
            {Array.from({ length: 4 }).map((_, i) => (
              <Skeleton key={i} style={{ height: '56px' }} />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
